import { Stack, Image, ImageFit, Label, PrimaryButton, DefaultButton, FontIcon, IStackTokens } from '@fluentui/react';
import React, { useContext, useEffect, useState } from 'react';
import styles from '../../styles/collectie.module.scss';
import {  TProduct, TSize } from '../../constants/types';
import { calculateProductBTCPrice } from '../../helpers/General';
import PulseLabel from '../../components/pulseLabelComponent';
import { AlertButtonComponent } from '../../components/alertButtonComponent';
import GlobalContext from '../../_contexts/GlobalContext';

export interface IproductComponentProps {
    product: TProduct;
    onImageClick: Function;
    eurprice: number;
    satprice: number;
    imageSize?: TSize;
    onBuyClick: Function;
    hideSwipe: boolean;
    SetSelectedProductForAlert?: Function;
    AlertCoachmarkVisible: boolean;
}
  
const Product : React.FunctionComponent<IproductComponentProps> = (props : IproductComponentProps) => {
    const [product, setproduct] = useState<TProduct>(calculateProductBTCPrice(props.product, props.satprice, props.eurprice));
    const [selectedImageIdex, setselectedImageIdex] = useState<number>(0);
    const [added, setadded] = useState<boolean>(false);
    const [notAdded, setnotAdded] = useState<boolean>(false);
    const [startSwipe, setstartSwipe] = useState<number>(-1);
    const [swipeHidden, setswipeHidden] = useState<boolean>(props.hideSwipe);
    const [endSwipe, setendSwipe] = useState<number>(-1);

    const productTokens: IStackTokens = {
        childrenGap: 10,
        padding: 5
    };

    const { Strings, BitcoinEnabled } = useContext(GlobalContext);

    useEffect(() => {
        swipeTimeout();
    },[]);

    useEffect(() => {
        setproduct(calculateProductBTCPrice(props.product, props.satprice, props.eurprice));
    },[props.product]);
            
    function swipeTimeout() {
        setTimeout(() => {
            setswipeHidden(true);
                setTimeout(() => {
                    setswipeHidden(false);
                    swipeTimeout();
                }, 60000);
        }, 2000);
    }

    function tryAddToChart() {
        let done = false;
        if (product.available > 0) {
            done = props.onBuyClick(product); 
        }
        if (done) {
            setadded(true);
            setTimeout(() => {
                setadded(false);
            }, 500);
        } else {
            setnotAdded(true);
            setTimeout(() => {
                setnotAdded(false);
            }, 500);
        }
    }

    function swipeEnd(e) {
        if (startSwipe != -1 && endSwipe != -1) {
            if ((endSwipe - startSwipe) > 20) {
                selectedImageIdex > 0 ? setselectedImageIdex(selectedImageIdex-1) : setselectedImageIdex(props.product.imageUrls.length -1);
            } else if ((startSwipe - endSwipe) > 20) {
                selectedImageIdex+1 < props.product.imageUrls.length ? setselectedImageIdex(selectedImageIdex+1) : setselectedImageIdex(0);
            }
            setstartSwipe(-1);
            setendSwipe(-1);
        }
    }

    function nextImage() {
        let newIndex = selectedImageIdex + 1;
        if (newIndex < props.product.imageUrls.length) {
            setselectedImageIdex(newIndex);
        } else {
            setselectedImageIdex(0);
            newIndex = 0;
        }
        props.onImageClick(props.product.imageUrls[newIndex], nextImage, previousImage);
    }

    function previousImage() {
        let newIndex = selectedImageIdex - 1;
        if (selectedImageIdex > 0) {
            setselectedImageIdex(selectedImageIdex - 1);
        } else {
            setselectedImageIdex(props.product.imageUrls.length -1);
            newIndex = props.product.imageUrls.length -1;
        }
        props.onImageClick(props.product.imageUrls[newIndex], nextImage, previousImage);
    }

    return (
        <Stack className={styles.product}>
            <Stack style={{height:"100%"}}>
                <Stack horizontal >
                    <div className={`${styles.productTitleContainer}`}>
                        <Stack horizontal horizontalAlign='space-between'>
                            <Stack horizontal horizontalAlign='start'>
                                <div className={styles.productTitle}>
                                    {product.title}
                                </div>
                            </Stack>
                            <Stack horizontal horizontalAlign='end' className={styles.cardHeaderBanner}>
                                {product.available === 0 && <Image {...{imageFit: ImageFit.centerContain,
                                        className: styles.soldOut,
                                        src: process.env.PUBLIC_URL + `/assets/soldout.webp`,
                                        styles: props => ({ root: { margin: 0, zIndex: 1} }),
                                    }} alt="" />}
                            </Stack>
                        </Stack>
                    </div>
                </Stack> {/* style={{backgroundColor:'white', borderRadius:10}} */}
                <Stack horizontal verticalAlign='center' horizontalAlign='center' onClick={ () => { props.onImageClick(product.imageUrls[selectedImageIdex], nextImage, previousImage); }}>
                    <Image {...{imageFit: ImageFit.centerContain,
                                className: styles.productCompImg,
                                src: product.imageUrls[selectedImageIdex],
                                width: props.imageSize?.x,
                                height: props.imageSize?.y,
                                onTouchStart: (e) => { setstartSwipe(e.targetTouches[0].clientX); },
                                onTouchMove: (e) => { setendSwipe(e.targetTouches[0].clientX); },
                                onTouchEnd: swipeEnd,
                                onError: ( e ) => { e.currentTarget.onerror = null; 
                                                    e.currentTarget.src=`${process.env.PUBLIC_URL}/assets/NoImgFound.webp`},
                                styles: props => ({ root: { margin: 0, cursor: "pointer" }, image: {  } }),
                            }} alt="" />
                </Stack>
                <Stack horizontalAlign='center' horizontal verticalAlign='center'>
                    <FontIcon aria-label="Volgende" className={styles.prevNextIcon} onClick={() => {selectedImageIdex > 0 ? setselectedImageIdex(selectedImageIdex-1) : setselectedImageIdex(product.imageUrls.length -1)}} iconName="ChevronLeft" />
                    {selectedImageIdex+1} / {product.imageUrls.length} 
                    <FontIcon aria-label="Volgende" className={styles.prevNextIcon} onClick={() => {selectedImageIdex+1 < product.imageUrls.length ? setselectedImageIdex(selectedImageIdex+1) : setselectedImageIdex(0)}} iconName="ChevronRight" />
                </Stack>
                <Stack className={styles.productInfoMain}>
                    <Stack className={styles.productInfo}>
                        <Label>{product.description}</Label>
                        <hr className={styles.cardInfohr} />
                        <div className={styles.divTable} style={{width:"max-content"}}>
                            {product.tags.map(tag => {
                                    return  <div className={styles.divTableRow}>
                                                <div className={styles.divTableCell}>
                                                        <Label><b>{tag.key}</b></Label>
                                                </div>
                                                <div className={styles.divTableCell}>
                                                        <Label>&nbsp;&nbsp;{tag.value}</Label>
                                                </div>
                                            </div>
                            })}
                        </div>
                    </Stack>
                    <Stack verticalAlign='end' style={{height:"100%"}}>
                        <hr className={styles.cardInfohr} />
                        <Stack horizontal horizontalAlign='space-between'>
                            <Stack verticalAlign='center'>
                                <PulseLabel style={{fontSize:"small!important",fontWeight:"bold"}} text={`€ ${parseFloat(product.priceInEUR.toFixed(2))}`} />
                                {BitcoinEnabled &&
                                    <Stack horizontal>
                                        <Image className={styles.btciconsmall}
                                            style={{ cursor: "default" }}
                                            src={`${process.env.PUBLIC_URL}/assets/btcicon.png`}
                                        />
                                        <PulseLabel style={{fontSize:"small!important"}} text={`${product.priceInSats} sats`} />
                                    </Stack>}
                            </Stack>
                            <Stack horizontal horizontalAlign='end' className={styles.butButtonDiv}>
                                {product.priceInUSD != 0 && product.available > 0 ?
                                    <FontIcon style={{width:100, maxHeight:"90%", verticalAlign:"middle", fontSize:25, backgroundColor:"#30a7d7"}} 
                                                aria-label={Strings?.AddToCart} 
                                                onClick={() => {tryAddToChart();}} 
                                                className={`${styles.buyButton} ${added ? styles.added : notAdded ? styles.notAdded : ""}`} 
                                                iconName={added ? "ShoppingCartSolid" : "ShoppingCart"} />
                                    : <AlertButtonComponent Visible={props.AlertCoachmarkVisible} OnClick={() => { props.SetSelectedProductForAlert(product); }} />
                                }
                            </Stack>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>
    );
}

export default Product;